<template>
  <div
    v-if="artists.length > 0"
    class="artist-list artist-list__selected">
    <a
      v-for="item in artists"
      :key="item.id"
      class="selected-artist-list b-1"
      href="#"
      @click.prevent="removeSelectedArtist(item)">
      <div
        :style="`background-image: url(/images/${item.image_path ? item.image_path : null})`"
        class="pic">
      </div>
      <span class="artist-list__name_text selected-artist-name-text">
        {{ item.name_ja }}
      </span>
      <span
        v-if="item && item.isRemovable"
        class="mdi mdi-minus-circle-outline remove-icon">
      </span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'SelectedArtist',
  props: {
    artists: {
      type: Array,
      default: () => [],
    },
    belongsTo: {
      type: String,
      required: true,
    },
  },
  methods: {
    removeSelectedArtist(data) {
      if (data && data.isRemovable) {
        this.$emit('notify', { data, belongsTo: this.belongsTo })
      }
    },
  },
}
</script>
<style scoped>
.b-1 {
  border: 1px solid #dadada
}

.artist-list {
  gap: 5px;
}

.selected-artist-name-text:hover,.remove-icon:hover {
  color: #ff2289;
}
</style>
